module.exports = __webpack_public_path__ + "img/cocina2.00342e45.svg";